/* ==========================================================
   SS02 — cart drawer + free gifts
   ========================================================== */
(function(){
  'use strict';

  var body = document.body;

  // ---------- helpers ----------
  function money(cents){
    return '$' + (cents/100).toFixed(2).replace(/\.00$/,'');
  }

  function openCart(){ body.classList.add('cart-open'); }
  function closeCart(){ body.classList.remove('cart-open'); }

  // ---------- cart drawer ----------
  document.addEventListener('click', function(e){
    // open drawer from any cart link/button
    var opener = e.target.closest('[data-cart-open], .cart-btn');
    if (opener){
      e.preventDefault();
      openCart();
      refreshCart();
      return;
    }

    if (e.target.closest('[data-cart-close]')){
      e.preventDefault();
      closeCart();
      return;
    }

    // remove a line item without a page reload
    var rm = e.target.closest('[data-cart-remove]');
    if (rm){
      e.preventDefault();
      changeLine(parseInt(rm.dataset.line, 10), 0);
      return;
    }

    // gift popup
    if (e.target.closest('[data-gift-toggle]')){
      body.classList.toggle('gifts-open');
      return;
    }
  });

  document.addEventListener('keydown', function(e){
    if (e.key === 'Escape'){
      closeCart();
      body.classList.remove('gifts-open');
    }
  });

  // ---------- add to cart (product page) ----------
  var pform = document.getElementById('ProductForm');
  if (pform){
    pform.addEventListener('submit', function(e){
      e.preventDefault();
      var btn = pform.querySelector('[type=submit]');
      var label = btn ? btn.textContent : '';
      if (btn){ btn.disabled = true; btn.textContent = 'Adding…'; }

      fetch('/cart/add.js', {
        method: 'POST',
        headers: {'Content-Type':'application/json', 'Accept':'application/json'},
        body: JSON.stringify({
          id: pform.querySelector('[name=id]').value,
          quantity: 1
        })
      })
      .then(function(r){ return r.json(); })
      .then(function(){
        if (btn){ btn.disabled = false; btn.textContent = label; }
        openCart();
        refreshCart();
      })
      .catch(function(){
        if (btn){ btn.disabled = false; btn.textContent = label; }
        pform.submit();
      });
    });
  }

  // ---------- change a line quantity ----------
  function changeLine(line, qty){
    fetch('/cart/change.js', {
      method: 'POST',
      headers: {'Content-Type':'application/json', 'Accept':'application/json'},
      body: JSON.stringify({line: line, quantity: qty})
    })
    .then(function(r){ return r.json(); })
    .then(function(){ refreshCart(); });
  }

  // ---------- refresh drawer contents ----------
  function refreshCart(){
    fetch('/cart.js', {headers:{'Accept':'application/json'}})
      .then(function(r){ return r.json(); })
      .then(function(cart){
        // counts + total
        document.querySelectorAll('[data-cart-count], #CartCount').forEach(function(el){
          el.textContent = cart.item_count;
        });
        var totalEl = document.querySelector('[data-cart-total]');
        if (totalEl) totalEl.textContent = money(cart.total_price);

        renderItems(cart);
        renderGifts(cart.total_price);
      });
  }

  function renderItems(cart){
    var wrap = document.querySelector('[data-cart-items]');
    if (!wrap) return;

    if (!cart.items.length){
      var shopUrl = wrap.dataset.shopUrl || '/collections/all';
      wrap.innerHTML =
        '<div class="cd-empty"><p>Your cart is empty</p>' +
        '<a class="btn" href="'+shopUrl+'">Shop the drop</a></div>';
      return;
    }

    wrap.innerHTML = cart.items.map(function(item, i){
      var img = item.image
        ? item.image.replace(/(\.[a-z]+)(\?|$)/i, '_200x$1$2')
        : '';
      var variant = (item.variant_title && item.variant_title.indexOf('Default') === -1)
        ? item.variant_title + ' · ' : '';
      return '' +
        '<div class="cd-item">' +
          (img ? '<img src="'+img+'" alt="" width="200" height="200">' : '') +
          '<div class="cd-item-info">' +
            '<strong>'+item.product_title+'</strong>' +
            '<span>'+variant+'Qty '+item.quantity+'</span>' +
            '<a href="#" data-cart-remove data-line="'+(i+1)+'">Remove</a>' +
          '</div>' +
          '<div class="cd-item-price">'+money(item.original_line_price)+'</div>' +
        '</div>';
    }).join('');
  }

  // ---------- free gifts progress ----------
  function renderGifts(totalCents){
    var tiers = Array.prototype.slice.call(document.querySelectorAll('.gift-tier'));
    if (!tiers.length) return;

    var unlocked = 0;
    var next = null;

    tiers.forEach(function(t){
      var amt = parseInt(t.dataset.tier, 10);
      if (totalCents >= amt){
        t.classList.remove('locked');
        unlocked++;
      } else {
        t.classList.add('locked');
        if (next === null) next = amt;
      }
    });

    var countEl = document.querySelector('[data-gift-count]');
    if (countEl) countEl.textContent = unlocked;

    var top = parseInt(tiers[tiers.length-1].dataset.tier, 10);
    var bar = document.querySelector('[data-gift-bar]');
    if (bar) bar.style.width = Math.min(100, (totalCents/top)*100) + '%';

    var cta = document.querySelector('[data-gift-cta]');
    if (cta){
      cta.innerHTML = next
        ? 'Add <b>'+money(next - totalCents)+'</b> to unlock your next gift'
        : 'All gifts unlocked &#10022;';
    }

    // earned gifts as distinct FREE rows under the cart items
    var giftWrap = document.querySelector('[data-cart-gifts]');
    var giftList = document.querySelector('[data-cart-gifts-list]');
    if (giftWrap && giftList){
      var earned = tiers.filter(function(t){
        return totalCents > 0 && totalCents >= parseInt(t.dataset.tier, 10);
      });
      if (earned.length){
        giftList.innerHTML = earned.map(function(t){
          var nameEl = t.querySelector('.name');
          var nm = nameEl ? nameEl.textContent : 'Gift';
          return '<div class="cd-gift">' +
                   '<span class="check">&#10003;</span>' +
                   '<span class="dots"></span>' +
                   '<span class="name">' + nm + '</span>' +
                 '</div>';
        }).join('');
        giftWrap.hidden = false;
      } else {
        giftList.innerHTML = '';
        giftWrap.hidden = true;
      }
    }
  }

  // initial paint
  refreshCart();
})();
